import { useState } from 'react';
import { policiesAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { AdminPageShell } from '../components/AdminShared';

export default function AdminPoliciesPage() {
  const [policy, setPolicy] = useState(null);
  const [orgId, setOrgId] = useState('');

  const loadPolicy = async (id) => {
    if (!id) return;
    setOrgId(id);
    try { const r = await policiesAPI.get(id); setPolicy(r.data); } catch (e) { console.error(e); }
  };

  const update = async (field, value) => {
    if (!orgId) return;
    const u = { ...policy, [field]: value };
    setPolicy(u);
    try { await policiesAPI.update(orgId, u); } catch (e) { console.error(e); }
  };

  return (
    <AdminPageShell title="Policies" testId="admin-policies-page" maxWidth="2xl">
      <div className="rounded-lg border bg-card p-6 mb-6">
        <h3 className="font-semibold mb-4" style={{ fontFamily: 'DM Sans' }}>Load Organization Policy</h3>
        <div className="flex gap-3">
          <Input placeholder="Enter Org ID" value={orgId} onChange={e => setOrgId(e.target.value)} data-testid="policy-org-id-input" />
          <Button onClick={() => loadPolicy(orgId)} className="bg-[hsl(var(--brand))] hover:bg-[hsl(var(--brand))]/90 text-white" data-testid="load-policy-button">Load</Button>
        </div>
        <div className="flex gap-2 mt-2">
          <Button variant="outline" size="sm" onClick={() => loadPolicy('org-acme-legal')}>Acme Legal</Button>
          <Button variant="outline" size="sm" onClick={() => loadPolicy('org-global-law')}>Global Law</Button>
        </div>
      </div>
      {policy && (
        <div className="rounded-lg border bg-card p-6 space-y-6" data-testid="policy-editor">
          <h3 className="font-semibold" style={{ fontFamily: 'DM Sans' }}>Policy: {orgId}</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div><Label className="font-medium">Allow Transcript</Label><p className="text-xs text-muted-foreground">Users can toggle transcript visibility</p></div>
              <Switch checked={policy.transcript_allowed} onCheckedChange={v => update('transcript_allowed', v)} data-testid="policy-transcript-toggle" />
            </div>
            <div className="flex items-center justify-between">
              <div><Label className="font-medium">Domestic Only</Label><p className="text-xs text-muted-foreground">Restrict interpreters to US-based only</p></div>
              <Switch checked={policy.domestic_only} onCheckedChange={v => update('domestic_only', v)} data-testid="policy-domestic-toggle" />
            </div>
            <div className="flex items-center justify-between">
              <div><Label className="font-medium">High Risk Ack Required</Label><p className="text-xs text-muted-foreground">Require user to acknowledge high-risk translations</p></div>
              <Switch checked={policy.high_risk_ack_required} onCheckedChange={v => update('high_risk_ack_required', v)} data-testid="policy-highrisk-toggle" />
            </div>
            <div>
              <Label className="font-medium mb-2 block">Domain Level</Label>
              <Select value={policy.domain_level} onValueChange={v => update('domain_level', v)}>
                <SelectTrigger data-testid="policy-domain-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="LITERAL">Literal</SelectItem>
                  <SelectItem value="BALANCED">Balanced</SelectItem>
                  <SelectItem value="LEGAL_EQUIV">Legal Equivalence</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      )}
    </AdminPageShell>
  );
}
